// @flow
import * as React from 'react';
import styled from 'styled-components';
import { colors } from 'seedling/constants';
import Button from 'seedling/components/button';
import { DropdownArrow } from 'seedling/components/dropdown_select/components';

export type ExpandableButtonProps = {
  primaryButtonText: string,
  onPrimaryClick: () => void,
  onDropdownClick: () => void,
  isOpen: boolean,
  width?: number,
  disabled?: boolean,
  children: React.ChildrenArray<?any>,
};

export default class ExpandableButton extends React.Component<ExpandableButtonProps> {
  render() {
    const {
      primaryButtonText,
      onPrimaryClick,
      onDropdownClick,
      disabled,
      width,
      isOpen,
      children,
      ...otherProps
    } = this.props;
    return (
      <OuterWrapper width={width} className="expandable-button-wrapper">
        <ButtonWrapper>
          <DefaultActionButton
            onClick={onPrimaryClick}
            disabled={disabled}
            {...otherProps}
          >
            {primaryButtonText}
          </DefaultActionButton>
          <DropdownButton onClick={onDropdownClick} disabled={disabled}>
            <DropdownArrow menuIsOpen={isOpen} />
          </DropdownButton>
        </ButtonWrapper>
        <ContentWrapper isOpen={isOpen}>{children}</ContentWrapper>
      </OuterWrapper>
    );
  }
}

const OuterWrapper = styled.div`
  ${({ width }) => width && `width: ${width}px;`}
  position: relative;
`;

const ButtonWrapper = styled.div`
  display: flex;
`;

const DefaultActionButton = styled(Button)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  flex: 1 1;
`;

const DropdownButton = styled(Button)`
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 10px;
`;

const ContentWrapper = styled.div`
  border: 1px solid ${colors.lightGrey};
  border-top: 0;
  position: absolute;
  box-sizing: border-box;
  padding: 10px;

   width: 100%;

   background: white;
  z-index: 999;

  ${({ isOpen }) => `display: ${isOpen ? 'block' : 'none'};`}
`;
